import type { IOVPracticeConfigurationUpsertData } from "@common-shared/types/requestData/oneVerifyRequestData.types"
import type { IPractice } from "@common-shared/types/responseData/commonResponseData.types"
import type { IOneVerifyPracticeConfiguration } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import { UtilHelper } from "../helpers/util.helper"

export class PracticeConfigurationsService {
    /**
     * Get full practice configuration values.
     */
    static async getPracticeConfiguration(
        practice: IPractice,
    ): Promise<IOneVerifyPracticeConfiguration | undefined> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.PRACTICE_CONFIGURATIONS_GET.replace(
                ":practiceId",
                practice.id.toString(),
            ),
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }

    /**
     * Upsert practice configuration values.
     */
    static async upsertPracticeConfiguration(
        practice: IPractice,
        data: Pick<IOVPracticeConfigurationUpsertData, "payerMappingsMode">,
    ): Promise<IOneVerifyPracticeConfiguration | undefined> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.PRACTICE_CONFIGURATIONS_UPSERT.replace(
                ":practiceId",
                practice.id.toString(),
            ),
            data,
            "PATCH",
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }
}
